/**
 * @Author: Ali2vu <751815097@qq.com>
 * @Date: 2020-03-30 15:23:09
 * @LastEditors: Ali2vu
 * @LastEditTime: 2020-08-12 11:29:23
 */
import passport from './passport'
import common from './common'
import statistics from './statistics'
import menu from './menu'
import permissions from './permissions'
import roles from './roles'
import user from './user'
import setting from './setting'
import carousel from './carousel'
import adPosition from './ad_position'
import link from './link'
import category from './category'
import article from './article'
import live from './live'
import lecturer from './lecturer'
import attachment from './attachment'
import sysLog from './sys_log'
import company from './company'
import openapi from './openapi'
import openapiServer from './openapi_server'
import adminTrade from './admin_trade'
import ws from './ws'
import settlement from './settlement'
import customer from './customer'
import bill from './bill'
import oss from './oss'
import home from './home'
import mx from './mx'
import contract from './contract'
import task from './task'
import adminTask from './admin_task'
import adminContract from './admin_contract'
import adminBill from './admin_bill'
import exportPdf from './exportPdf'
import announce from './announce'
import mission from './mission'
import invoice from './invoice'
import adminInvoice from './admin_invoice'
import  invoicePartner from './invoice_partner'
import login from './login'//登录
import channel from './channel'//渠道商户
import api_merchant from './api_merchant'//api商户
import oem from './oem'//oem
import staff from './staff'//员工
import backstage_role from './backstage_role'//角色管理
import buser from './buser'
import individual from './individual'//集群注册
import channelreader from "./channelreater" //渠道返佣
import warn from "./warn" //预警记录
import businessapproval from "./businessapproval"
import paihuoEmployment from "./paihuo_employment.js" //用工企业
import paihuoHumanResources from "./paihuo_human_resources.js" //人力资源公司
import paihuoProject from "./paihuo_project.js" //派活项目
import setting_age_white from "./setting_age_white.js" //设置年龄白名单
import setting_quota_white from "./setting_quota_white" //设置下发限额白名单
import boos_white_list from './boos_white_list.js'//董监高
import examine_white_list from "./auto_examine_white_list.js" //自动审核白名单
import signed_bank_card from './signed_bank_card.js' //签约银行卡必填
import esignWhiteList from './esign_whiteList.js' //E签宝白名单
import pinganWhite from './pingan_white.js' //平安入金白名单
import personTax from './personTax.js' //平安入金白名单
import laowu from './laowu.js' //劳务公司
import individualTax from './individualTax.js' //个税
import delivery from './delivery.js'//任务审核
import contract_config from './contract_config.js'//签约配置
import training from './training.js'//培训管理
export default {
  //个人完税记录
  ...personTax,
  // 平安入金白名单
  ...pinganWhite,
  // E签宝白名单
  ...esignWhiteList,
  // 自动审核白名单
  ...examine_white_list,
  // 通行证
  ...passport,
  // 通用
  ...common,
  // 统计数据
  ...statistics,
  // 菜单
  ...menu,
  // 权限
  ...permissions,
  // 角色
  ...roles,
  // 用户
  ...user,
  // 基础配置
  ...setting,
  // 轮播图
  ...carousel,
  // 广告位
  ...adPosition,
  // 友情链接
  ...link,
  // 分类管理
  ...category,
  // 文章管理
  ...article,
  // 直播管理
  ...live,
  // 讲师管理
  ...lecturer,
  // 附件管理
  ...attachment,
  // 系统日志管理
  ...sysLog,
  // 公司管理
  ...company,
  // 开放平台管理
  ...openapi,
  // 接口配置管理
  ...openapiServer,
  // 交易流水
  ...adminTrade,
  // 网商相关接口
  ...ws,
  // 银行中心->账户资料
  ...settlement,
  // 银行中心->人才签约
  ...customer,
  // 银行中心->结算清单
  ...bill,
  //上传oss
  ...oss,
  //首页
  ...home,
  ...mx,
  //账户
  ...contract,
  ...task,
  ...adminTask,
  ...adminContract,
  ...adminBill,
  ...exportPdf,//获取协议双方
  ...announce,//公告管理
  ...mission,//生成邀请二维码
  ...invoice,//在线开票
  ...adminInvoice,//开票审核
  ...invoicePartner,//开票管理
  ...login,//登录
  ...channel,//渠道商户
  ...api_merchant,//api商户
  ...oem,//oem
  ...staff,//员工
  ...backstage_role,//角色管理
  ...buser,//B端用户管理
  ...individual,//集群注册
  ...channelreader,//渠道返佣
  ...warn,//预警记录
	...businessapproval,//预警记录
	...paihuoEmployment,//用工企业
	...paihuoHumanResources,//人力资源公司
	...paihuoProject,//派活项目
	...setting_age_white,//设置年龄白名单
	...setting_quota_white,//设置下发限额白名单
	...boos_white_list,//董监高
  ...signed_bank_card,//签约银行卡必填
  ...laowu,
  ...individualTax,
  ...delivery,
  ...contract_config,
  ...training
}
